export default {
	section_banner: {
		title: {
			one: 'Crypto Assets',
		},
		main_title: {
			one: 'Selling',
		},
		paragraph: {
			one: 'Is it hard to sell your crypto assets? Still waiting for a buyer? With JPWorldPay, you no longer need to wait. Our platform connects you instantly with the market, making it quick and easy to convert your assets whenever you need.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	credit_system: {
		title: 'Easy To Sell',
		main_title: {
			one: 'Selling',
			two: 'Cryptocurrencies',
			three: 'Just',
			four: 'Got Easier',
		},
		paragraph: {
			one: 'Customer to Customer Sales – Customers Sell Directly to JPWorldPay. Sell in the way you prefer, whether through direct listings or instant sales.',
			two: 'JPWorldPay empowers users with flexible options, making it easy to turn your digital assets into value on your terms.Enjoy a secure, convenient, and user-driven selling experience.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},

	charging_sec: {
		title: 'With One Click Of A Button',
		sub_title: {
			one: 'The',
			two: 'Exchange Rate',
			three: 'Is Automatically Applied',
		},
		paragraph: {
			one: 'With one click of a button, the current price is automatically applied, so you can sell right away. This instant pricing feature ensures speed and accuracy, saving you the hassle of manual updates or delays.',
			two: 'Whether you are in a rush or simply value efficiency, JPWorldPay makes selling your crypto assets seamless and stress-free.',
		},
		cta_buttons: {
			one: 'Exchange Now',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
